function padTime(time: number): string {
  return time < 10 ? `0${time}` : `${time}`;
}

export { padTime };
